import { C_API, C_RESP, C_STORAGE } from '@/constant';
import Http from '@emooa/http';
import { getStorage, removeStorage } from '../storage';
import { AxiosRequestConfig } from 'axios';

const bool = !!getStorage(C_STORAGE.AUTH);

const axios = new Http({
  colorPrimary: '#1a6cba',
  mapping: {
    code: 'code',
    message: ['notice', 'msg', 'message'],
    ok: C_RESP.OK,
  },
  modal: {
    style: { top: 100 },
    info: {
      [C_RESP.ERR_401]: {
        content: (
          <div className="pb-2.5 pt-5">
            {bool ? (
              <span
                dangerouslySetInnerHTML={{
                  __html:
                    '您好，您当前登录已失效，请点击下方 <span class="color-primary">重新登录</span> 按钮。',
                }}
              />
            ) : (
              <span
                dangerouslySetInnerHTML={{
                  __html:
                    '您好，您当前账号还未登录，请点击下方 <span class="color-primary">登录</span> 按钮。',
                }}
              />
            )}
          </div>
        ),
        onOk: () => {
          removeStorage(C_STORAGE.AUTH);
          window.location.href = `/login`;
        },
        okText: bool ? '重新登录' : '登录',
      },
      1000: {},
    },
  },
});

const instance = axios.create({
  baseURL: C_API.HOST_PATH,
  timeout: C_API.TIMEOUT,
});

instance.interceptors.request.use(config => {
  config.headers!['Authorization'] = `Bearer ${getStorage(C_STORAGE.TOKEN)}`;
  return config;
});

instance.interceptors.response.use(response => {
  if (response.status === 500) {
    return undefined;
  }

  if (
    response &&
    typeof response === 'object' &&
    'data' in response &&
    Object.keys(response).every(key => ['code', 'msg', 'data'].includes(key))
  ) {
    return response.data;
  }

  return response;
});

const http = {
  get<T = unknown>(url: string, config?: AxiosRequestConfig) {
    return instance.get(url, config) as Promise<T>;
  },
  post<T = unknown>(url: string, data?: unknown, config?: AxiosRequestConfig) {
    return instance.post(url, data, config) as Promise<T>;
  },
  patch<T = unknown>(url: string, data?: unknown, config?: AxiosRequestConfig) {
    return instance.patch(url, data, config) as Promise<T>;
  },
  put<T = unknown>(url: string, data?: unknown, config?: AxiosRequestConfig) {
    return instance.put(url, data, config) as Promise<T>;
  },
  delete<T = unknown>(url: string, config?: AxiosRequestConfig) {
    return instance.delete(url, config) as Promise<T>;
  },
  async download(
    url: string,
    config: AxiosRequestConfig & { fileName?: string } = {},
  ) {
    const { fileName, ...rest } = config;
    const res = await instance.request({
      url,
      responseType: 'blob',
      ...rest,
    } as AxiosRequestConfig) as any;
    const data = res?.data || res;
    const blob = data instanceof Blob ? data : new Blob([data]);
    const link = document.createElement('a');
    const disposition = res?.headers?.['content-disposition'];
    const matched = disposition?.match(/filename="?([^"]+)"?/);
    link.href = URL.createObjectURL(blob);
    link.download = decodeURIComponent(matched?.[1] || fileName || `download_${Date.now()}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  },
};

export default http;
